import FirstName from './firstname'

export default FirstName
